<h2 class="text-center">Shipping Address</h2>
<p>Please enter your shipping address information.</p>

<fgbcl-errors></fgbcl-errors>

<form [formGroup]="shippingForm">
  <div class="form-row">
    <div class="form-group col-md-6">
      <label for="FirstName">
        First Name
        <span class="text-danger">*</span>
      </label>
      <input
        id="FirstName"
        class="form-control"
        type="text"
        formControlName="FirstName"
        [ngClass]="{ 'is-invalid': hasSubmitted && !!shippingForm.controls.FirstName.errors }"
        required
      />
      <div class="invalid-feedback">Please enter your first name.</div>
    </div>

    <div class="form-group col-md-6">
      <label for="Surname">
        Surname
        <span class="text-danger">*</span>
      </label>
      <input
        id="Surname"
        class="form-control"
        type="text"
        formControlName="Surname"
        [ngClass]="{ 'is-invalid': hasSubmitted && !!shippingForm.controls.Surname.errors }"
        required
      />
      <div class="invalid-feedback">Please enter your surname.</div>
    </div>
  </div>

  <div class="form-row">
    <div class="form-group col-md-6">
      <label for="EmailAddress">
        Email Address
        <span class="text-danger">*</span>
      </label>
      <input
        id="EmailAddress"
        class="form-control"
        type="text"
        formControlName="EmailAddress"
        [ngClass]="{ 'is-invalid': hasSubmitted && !!shippingForm.controls.EmailAddress.errors }"
        required
      />
      <div class="invalid-feedback">Please enter a valid email address.</div>
    </div>

    <div class="form-group col-md-6">
      <label for="HomeNumber">
        Phone Number
        <span class="text-danger">*</span>
      </label>
      <input
        id="HomeNumber"
        class="form-control"
        name="HomeNumber"
        type="tel"
        formControlName="HomeNumber"
        [ngClass]="{ 'is-invalid': hasSubmitted && !!shippingForm.controls.HomeNumber.errors }"
        required
      />
      <div class="invalid-feedback">Please enter a valid phone number.</div>
    </div>
  </div>

  <div class="form-group mt-2">
    <label for="Street">
      Street
      <span class="text-danger">*</span>
    </label>
    <input
      id="Street"
      class="form-control"
      name="Street"
      type="text"
      formControlName="Street"
      [ngClass]="{ 'is-invalid': hasSubmitted && !!shippingForm.controls.Street.errors }"
      required
    />
    <div class="invalid-feedback">Please enter a value.</div>
  </div>

  <div class="form-row">
    <div class="form-group col-md-6">
      <label for="Town">
        City
        <span class="text-danger">*</span>
      </label>
      <input
        id="Town"
        class="form-control"
        name="Town"
        type="text"
        formControlName="Town"
        [ngClass]="{ 'is-invalid': hasSubmitted && !!shippingForm.controls.Town.errors }"
        required
      />
      <div class="invalid-feedback">Please enter a value.</div>
    </div>

    <div class="form-group col-md-6">
      <label for="County">
        State
        <span class="text-danger">*</span>
      </label>
      <input
        id="County"
        class="form-control"
        name="County"
        type="text"
        formControlName="County"
        [ngClass]="{ 'is-invalid': hasSubmitted && !!shippingForm.controls.County.errors }"
        required
      />
      <div class="invalid-feedback">Please enter a value.</div>
    </div>
  </div>

  <div class="form-row">
    <div class="form-group col-md-6">
      <label for="Postcode">
        Zip Code
        <span class="text-danger">*</span>
      </label>
      <input
        id="Postcode"
        class="form-control"
        name="Postcode"
        type="text"
        formControlName="Postcode"
        [ngClass]="{ 'is-invalid': hasSubmitted && !!shippingForm.controls.Postcode.errors }"
        required
      />
      <div class="invalid-feedback">Please enter a valid zip code.</div>
    </div>

    <div class="form-group col-md-6">
      <label for="Country">
        Country
        <span class="text-danger">*</span>
      </label>
      <input
        id="Country"
        class="form-control"
        name="Country"
        type="text"
        formControlName="Country"
        [ngClass]="{ 'is-invalid': hasSubmitted && !!shippingForm.controls.Country.errors }"
        required
      />
      <div class="invalid-feedback">Please enter a value.</div>
    </div>
  </div>
</form>

<fgb-registration-navigation (nextButtonClicked)="submitStep()" [stepType]="stepType"></fgb-registration-navigation>
